<template>
  <q-dialog
    v-model="shown"
    data-test-id="global-widget-settings-form"
  >
    <q-card
      :style=" $q.screen.gt.xs? 'max-height: calc(100vh - 100px); margin-bottom: 50px; max-width: 600px' : undefined"
    >
      <q-card-section class="row items-center q-mx-xs">
        <div class="text-h6">
          Global Widget Settings
        </div>
        <q-space />
        <q-btn
          v-close-popup
          icon="close"
          flat
          round
          dense
        />
      </q-card-section>
      <q-card-section>
        <div class="text-bold q-mb-sm">
          Visiblity
        </div>
        <div class="row q-col-gutter-md items-start">
          <q-toggle
            v-model="globalWidget.config.on"
            class="col-3"
            keep-color
            :color="globalWidget.on ? 'positive' : 'grey'"
            unchecked-icon="clear"
            checked-icon="check"
            label="On"
          />
          <q-select
            v-model="globalWidget.config.visible_for"
            class="col-9"
            label="Visible For"
            :options="visibilityOptions"
            bottom-slots
            map-options
            emit-value
            use-chips
            clearable
            multiple
          />
          <iso-date-input
            v-model="globalWidget.config.startDate"
            class="col-6"
            label="Start Date"
            clearable
            :rules="[
              () => !globalWidget.config.startDate || !globalWidget.config.endDate || globalWidget.config.startDate <= globalWidget.config.endDate || 'Date cannot postdate end date',
            ]"
          />
          <iso-date-input
            v-model="globalWidget.config.endDate"
            class="col-6"
            label="End Date"
            clearable
            :rules="[
              () => !globalWidget.config.startDate || !globalWidget.config.endDate || globalWidget.config.endDate >= globalWidget.config.startDate || 'Date cannot predate start date',
            ]"
          />
          <q-select
            :model-value="globalWidget.config.daysOfWeek"
            multiple
            use-chips
            class="col-12"
            label="Days of Week"
            :options="$constants.dayOfWeekNumbers"
            map-options
            emit-value
            bottom-slots
            @update:model-value="handleUpdateDaysOfWeek"
          />
          <q-toggle
            v-model="globalWidget.config.isDismissable"
            class="col-3"
            :color="globalWidget.on ? 'positive' : 'grey'"
            unchecked-icon="clear"
            checked-icon="check"
            label="Allow Dismiss"
          />
          <q-select
            v-model="globalWidget.config.restorationFrequency"
            class="col-9"
            :options="restorationFrequencyOptions"
            bottom-slots
            map-options
            emit-value
            clearable
            :disable="!globalWidget.config.isDismissable"
            label="Restoration Frequency"
          >
            <q-tooltip>
              The frequency for restoring a dismissed global widget.
            </q-tooltip>
          </q-select>
        </div>
      </q-card-section>
      <q-card-section>
        <div class="text-bold q-mb-sm">
          Advanced Styling
        </div>
        <div class="row q-col-gutter-md items-start">
          <q-input
            v-model="globalWidget.config.class"
            class="col-6"
            label="Classes"
            clearable
          />
          <q-input
            v-model="globalWidget.config.style"
            class="col-6"
            label="Styles"
            clearable
          />
        </div>
        <div class="row q-col-gutter-md q-mt-sm">
          <q-input
            v-model="globalWidget.styles"
            type="textarea"
            class="col-12"
            label="Custom CSS"
          />
        </div>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>
import GlobalWidget, { RESTORATION_FREQUENCY_OPTIONS, VISIBILITY_OPTIONS } from 'src/models/global-widget/GlobalWidget'
import { IsoDate } from 'src/models/Model'
import IsoDateInput from 'src/modules/admin/components/IsoDateInput'

export default {
  name: 'GlobalWidgetGenericSettingsForm',
  components: {
    IsoDateInput
  },
  configuration: ['publishedPages', 'currentCircuit'],
  props: {
    globalWidget: {
      type: GlobalWidget,
      required: true
    }
  },
  data () {
    return {
      shown: false
    }
  },
  created () {
    _.extend(this, {
      IsoDate,
      visibilityOptions: this.$mh.asOptions(VISIBILITY_OPTIONS.ALL),
      restorationFrequencyOptions: this.$mh.asOptions(RESTORATION_FREQUENCY_OPTIONS)
    })
  },
  methods: {
    show () {
      this.shown = true
    },
    handleUpdateDaysOfWeek (value) {
      // Preserved the circuit's ordering of the days of the week
      this.globalWidget.config.daysOfWeek = _.intersection(this.currentCircuit.daysOfWeekNumbers, value)
    }
  }
}

</script>
